import { StatusApi } from '@voladeum/client';
import { VoladeumResponse } from 'client/types';

import { Axios } from '../../axios';

import { normalizeStatuses } from './normalizers';
import { Status } from './types';

export class VoladeumStatuses extends Axios {
  async list(): Promise<VoladeumResponse<Status[]>> {
    const res = await this.get<VoladeumResponse<StatusApi[]>>('/v1/lookups/statuses');
    return {
      success: res.success,
      error: res.error,
      data: normalizeStatuses(res.data),
    };
  }
}
